module.exports = __webpack_public_path__ + "static/media/DK4055_04.ab8c28f5.jpg";